export const RESET_STATE = 'ADVANCED_CRUD_RESET_STATE';
export const CURRENT_ITEM = 'ADVANCED_CRUD_CURRENT_ITEM';

export const REQUEST_LOADING = 'ADVANCED_CRUD_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'ADVANCED_CRUD_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'ADVANCED_CRUD_REQUEST_FAILED';

export const CURRENT_ACTION = 'ADVANCED_CRUD_CURRENT_ACTION';
export const RESET_ACTION = 'ADVANCED_CRUD_RESET_ACTION';
